import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['summaryButton', 'mainWrapper']

  toggleSidebar(event) {
    var sidebar = $('.blue-sidebar')[0]
    if (!sidebar) {
      return
    }

    if (!this.hasSummaryButtonTarget) {
      return
    }

    if (!$.contains(sidebar, event.target)) {
      if (event.target == this.summaryButtonTarget) {
        this.handleToggle()
      } else {
        if (!$('.sidebar-wrapper').hasClass('hidden')) {
          this.handleToggle()
        }
      }
    }
  }

  handleToggle() {
    $('.sidebar-wrapper').toggleClass('hidden -right-20 block right-0')
    $(this.mainWrapperTarget).toggleClass('dark-bg-overlay')
    $('body').toggleClass('overflow-hidden')
    if ($(this.summaryButtonTarget).text() == 'Show summary') {
      $(this.summaryButtonTarget).text('Hide summary')
    } else {
      $(this.summaryButtonTarget).text('Show summary')
    }
  }
}
